import Apptimize from '@apptimize/apptimize-web-sdk'

export const getIntFromApptimize = (flag: string, defaultValue: number = 0) => {
  return Apptimize?.getInt(flag, defaultValue) ?? defaultValue
}
